var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"payment-setting"},[_c('edit',{ref:"edit",attrs:{"api":'settings',"fs":_vm.paymentFields,"id":'payment',"title":"Payment Setting"},on:{"saved":_vm.saved},scopedSlots:_vm._u([{key:"title",fn:function(ref){
var f = ref.f;
return [_c('h3',[_vm._v(_vm._s(f.heading))])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }